/** Read the `?ref=...` referral code from the current URL (lowercased, sanitised). */
export function getReferralCodeFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return null;
    const cleaned = raw.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 32);
    return cleaned || null;
  } catch {
    return null;
  }
}

/** Build a shareable referral URL given a code. */
export function buildReferralUrl(code) {
  if (typeof window === "undefined") return "";
  const u = new URL(window.location.origin);
  u.searchParams.set("ref", code);
  return u.toString();
}
